import React, { Component } from 'react';
import { Modal, Radio, Checkbox, DatePicker, message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import moment from 'moment';

const RadioGroup = Radio.Group;
const monthFormat = 'YYYY-MM'
const { MonthPicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

class ExportModal extends Component {
    state = {
        visible: false,
        searchParams: {},
        checkBoxObj: {
            departmentInfo: {
                isCheck: false,
                params: {},
            },
            projectDetail: {
                isCheck: false,
                params: {
                    exportType: 'departmentInfoByNameForSmo',
                },
            },
            departmentCrcInfo: {
                isCheck: false,
                params: {},
            },
            departmentGroupSpeedInfo: {
                isCheck: false,
                params: {
                    groupType: 'MONTH',
                    beginMonthTime: moment().format(monthFormat),
                    endMonthTime: moment().format(monthFormat),
                    beginTime: moment().format(dateFormat),
                    endTime: moment().format(dateFormat),
                },
            },
            departmentFilterAndRandomInfo: {
                isCheck: false,
                params: {
                    filterAndRandomStart: moment().format(dateFormat),
                    filterAndRandomEnd: moment().format(dateFormat),
                },
            },
            pcrc: {
                isCheck: false,
                params: {},
            },
            commentInformation: {
                isCheck: false,
                params: {},
            }
        }
    }

    show = (value) => {
        const { ids = {} } = value;
        const { arry = [] } = this.props;
        const params = { ...value };
        Object.keys(ids).forEach(item => {
            params[`ids[${item}]`] = ids[item];
        });
        arry.map((item, index) => {
            params[`departmentIds[${index}]`] = item;
        });
        delete params.ids;
        this.setState({
            searchParams: {
                ...params,
            },
            visible: true,
        });
    }

    handleCancel = () => {
        this.setState({
            visible: false,
            searchParams: {},
            checkBoxObj: {
                departmentInfo: {
                    isCheck: false,
                    params: {},
                },
                projectDetail: {
                    isCheck: false,
                    params: {
                        exportType: 'departmentInfoByNameForSmo',
                    },
                },
                departmentCrcInfo: {
                    isCheck: false,
                    params: {},
                },
                departmentGroupSpeedInfo: {
                    isCheck: false,
                    params: {
                        groupType: 'MONTH',
                        beginMonthTime: moment().format(monthFormat),
                        endMonthTime: moment().format(monthFormat),
                        beginTime: moment().format(dateFormat),
                        endTime: moment().format(dateFormat),
                    },
                },
                departmentFilterAndRandomInfo: {
                    isCheck: false,
                    params: {
                        filterAndRandomStart: moment().format(dateFormat),
                        filterAndRandomEnd: moment().format(dateFormat),
                    },
                },
                pcrc: {
                    isCheck: false,
                    params: {},
                },
                commentInformation: {
                    isCheck: false,
                    params: {},
                }
            }
        });
    }

    handleOk = () => {
        const {
            searchParams,
            checkBoxObj,
        } = this.state;

        let exportTypeArr = [];
        let sendParams = {};
        const checkBoxArr = Object.values(checkBoxObj);
        checkBoxArr.map(el => {
            const { isCheck, params } = el;
            if (isCheck) {
                const { exportType, ...rest } = params;
                exportTypeArr.push(exportType);
                sendParams = {...sendParams, ...rest};
            }
        });

        const options = {
            method: 'POST',
            url: `${API_URL.hospital.requestExportDepartmentListByInves}`,
            data: { 
                ...searchParams,
                exportType: exportTypeArr.filter(el => el).join(';'), 
                ...sendParams,
            },
            dataType: 'json',
            doneResult: (res) => {
                const { success } = res;
                message.success(success);
                this.setState({ loading: false });
                this.handleCancel();
            },
            errorResult: (() => {
                this.setState({ loading: false });
            })
        };
        $.sendRequest(options);
    }

    handleCheckBoxChange = (e, key) => {
        const { checkBoxObj } = this.state;
        const isCheck = e.target.checked;
        checkBoxObj[key].isCheck = isCheck;
        if (key === 'departmentInfo' || key === 'departmentGroupSpeedInfo' || key === 'departmentFilterAndRandomInfo'
        ||key === 'pcrc' || key === 'commentInformation' || key === 'departmentCrcInfo') {
            checkBoxObj[key].params.exportType = isCheck ? e.target.value : '';
        }
        this.setState({ checkBoxObj });
    }

    handleRadioChange = (e, key) => {
        const { checkBoxObj } = this.state;
        if (key === 'projectDetail') {
            checkBoxObj.projectDetail.params.exportType = e.target.value;
        } else if (key === 'departmentGroupSpeedInfo') {
            checkBoxObj.departmentGroupSpeedInfo.params.groupType = e.target.value;
        }
        this.setState({ checkBoxObj });
    }

    handleDateChange = (date, dateString, key) => {
        const { checkBoxObj } = this.state;
        if (key === 'beginMonthTime' || key === 'endMonthTime' || key === 'beginTime' || key === 'endTime') {
            checkBoxObj.departmentGroupSpeedInfo.params[key] = dateString;
        } else if (key === 'filterAndRandomStart' || key === 'filterAndRandomEnd') {
            checkBoxObj.departmentFilterAndRandomInfo.params[key] = dateString;
        }
        this.setState({ checkBoxObj });
    }

    render() {
        const {
            visible,
            checkBoxObj: {
                departmentInfo,
                projectDetail,
                departmentCrcInfo,
                departmentGroupSpeedInfo,
                departmentFilterAndRandomInfo,
                pcrc,
                commentInformation,
            }
        } = this.state;
        const { params: { beginMonthTime, endMonthTime, beginTime, endTime } } = departmentGroupSpeedInfo;
        const { params: { filterAndRandomStart, filterAndRandomEnd } } = departmentFilterAndRandomInfo;
        const radioStyle = {
            display: 'block',
            height: '24px',
            lineHeight: '24px',
        };
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label" style={{ marginLeft: -24 }}>请选择导出内容</label>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item checkBoxchildren" >
                                <div>
                                    <Checkbox
                                        value="departmentInfo"
                                        checked={departmentInfo.isCheck}
                                        onChange={e => this.handleCheckBoxChange(e, 'departmentInfo')}
                                    >医院科室信息列表</Checkbox>
                                </div>
                                <div>
                                    <Checkbox
                                        value="projectDetail"
                                        checked={projectDetail.isCheck}
                                        onChange={e => this.handleCheckBoxChange(e, 'projectDetail')}
                                    >项目明细</Checkbox>
                                </div>
                                {
                                    projectDetail.isCheck &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }}>
                                        <span style={{ marginLeft: 5, marginRight: 15 }}>项目明细导出方式</span>
                                        <RadioGroup onChange={e => this.handleRadioChange(e, 'projectDetail')} value={projectDetail.params.exportType} style={{ verticalAlign: 'top' }}>
                                            <Radio style={radioStyle} value="departmentInfoByNameForSmo">按医院科室分组导出(仅津石)</Radio>
                                            <Radio style={radioStyle} value="departmentInfoByNameForCompany">按医院科室分组导出(仅竞争公司)</Radio>
                                            <Radio style={radioStyle} value="departmentInfoByNameForAll">按医院科室分组导出(津石和竞争公司)</Radio>
                                            <Radio style={radioStyle} value="departmentInfoByAreaForSmo">按项目领域分组导出(仅津石)</Radio>
                                            <Radio style={radioStyle} value="departmentInfoByAreaForCompany">按项目领域分组导出(仅竞争公司)</Radio>
                                            <Radio style={radioStyle} value="departmentInfoByAreaForAll">按项目领域分组导出(津石和竞争公司)</Radio>
                                        </RadioGroup>
                                    </div>
                                }
                                <div>
                                    <Checkbox 
                                        onChange={e => this.handleCheckBoxChange(e, 'departmentCrcInfo')} 
                                        checked={departmentCrcInfo.isCheck} 
                                        value="departmentCrcInfo"
                                    >现任CRC人数（按医院科室）</Checkbox>
                                </div>
                                <div>
                                    <Checkbox
                                        onChange={e => this.handleCheckBoxChange(e, 'departmentGroupSpeedInfo')}
                                        checked={departmentGroupSpeedInfo.isCheck}
                                        value="departmentGroupSpeedInfo"
                                    >医院科室入组速率趋势</Checkbox>
                                </div>
                                {
                                    departmentGroupSpeedInfo.isCheck &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }}>
                                        <span style={{ marginLeft: 5, marginRight: 15 }}>入组速率统计方式:</span>
                                        <RadioGroup onChange={e => this.handleRadioChange(e, 'departmentGroupSpeedInfo')} value={departmentGroupSpeedInfo.params.groupType} >
                                            <Radio value="MONTH">按月</Radio>
                                            <Radio value="WEEK">按周</Radio>
                                        </RadioGroup>
                                    </div>
                                }
                                {
                                    (departmentGroupSpeedInfo.isCheck && departmentGroupSpeedInfo.params.groupType === "MONTH") &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }}>
                                        <span style={{ marginLeft: 5, marginRight: 15 }}>入组速率统计时间:</span>
                                        <MonthPicker
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            format={monthFormat}
                                            placeholder="请选择"
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'beginMonthTime')}
                                            allowClear={false}
                                            value={beginMonthTime ? moment(beginMonthTime) : null}
                                        />
                                        <span style={{ marginLeft: 10, marginRight: 10 }}>~</span>
                                        <MonthPicker
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            format={monthFormat}
                                            placeholder="请选择"
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'endMonthTime')}
                                            allowClear={false}
                                            value={endMonthTime ? moment(endMonthTime) : null}
                                        />
                                    </div>
                                }
                                {
                                    (departmentGroupSpeedInfo.isCheck && departmentGroupSpeedInfo.params.groupType === "WEEK") &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }}>
                                        <span style={{ marginLeft: 5, marginRight: 15 }}>入组速率统计时间:</span>
                                        <DatePicker
                                            format={dateFormat}
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            placeholder="请选择"
                                            allowClear={false}
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'beginTime')}
                                            value={beginTime ? moment(beginTime) : null}
                                        />
                                        <span style={{ marginLeft: 10, marginRight: 10 }}>~</span>
                                        <DatePicker
                                            format={dateFormat}
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            placeholder="请选择"
                                            allowClear={false}
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'endTime')}
                                            value={endTime ? moment(endTime) : null}
                                        />
                                    </div>
                                }
                                <div>
                                    <Checkbox
                                        onChange={e => this.handleCheckBoxChange(e, 'departmentFilterAndRandomInfo')}
                                        checked={departmentFilterAndRandomInfo.isCheck}
                                        value="departmentFilterAndRandomInfo"
                                    >医院科室筛选病例数/随机病例数</Checkbox>
                                </div>
                                {
                                    departmentFilterAndRandomInfo.isCheck &&
                                    <div style={{ marginLeft: 22, marginBottom: 15 }}>
                                        <span style={{ marginLeft: 5, marginRight: 15 }}>筛选/随机统计时间</span>
                                        <DatePicker
                                            format={dateFormat}
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            placeholder="请选择"
                                            allowClear={false}
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'filterAndRandomStart')}
                                            value={filterAndRandomStart ? moment(filterAndRandomStart) : null}
                                        />
                                        <span style={{ marginLeft: 10, marginRight: 10 }}>~</span>
                                        <DatePicker
                                            format={dateFormat}
                                            style={{ width: 120, verticalAlign: 'middle' }}
                                            placeholder="请选择"
                                            allowClear={false}
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'filterAndRandomEnd')}
                                            value={filterAndRandomEnd ? moment(filterAndRandomEnd) : null}
                                        />
                                    </div>
                                }
                                <div>
                                    <Checkbox
                                        onChange={e => this.handleCheckBoxChange(e, 'pcrc')}
                                        checked={pcrc.isCheck}
                                        value="pcrc"
                                    >科室PCRC</Checkbox>
                                </div>
                                <div>
                                    <Checkbox
                                        onChange={e => this.handleCheckBoxChange(e, 'commentInformation')}
                                        checked={commentInformation.isCheck}
                                        value="commentInformation"
                                    >点评信息</Checkbox>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/ExportModal.js